export const Categoryinfos = [
  {
    title: "Get your game on ...",
    name: "electronics",
    imgLink:
      "https://fakestoreapi.com/img/81Zt42ioCgL._AC_SX679_t.png",
  },
  {
    title: "Discover fashion trends",
    name: "women's clothing",
    imgLink: "https://fakestoreapi.com/img/51Y5NI-I5jL._AC_UX679_t.png",
  },
  {
    title: "9.9 Super Shopping Day",
    name: "men's clothing",
    imgLink:
      "https://fakestoreapi.com/img/71YXzeOuslL._AC_UY879_t.png",
  },
  {
    title: "Jewelery",
    name: "jewelery",
    imgLink: "https://fakestoreapi.com/img/71YAIFU48IL._AC_UL640_QL65_ML3_t.png",
  },
];
